import { useRecoilValue } from "recoil";

import Layout from "components/Layout";
import { useGetQuestionCount } from "hooks/apis/question";
import { userState } from "store/store";
import { useLocation } from "react-router-dom";

const QnaPage = () => {
  const { data } = useGetQuestionCount();
  const user = useRecoilValue(userState);
  const location = useLocation();
  const pathname = location.pathname;
  const search = decodeURI(location.search);

  return (
    <Layout
      title="QnA관리"
      nav={[
        {
          label: "QnA현황",
          links: [
            {
              label: "대기중",
              path: "/qna/ongoing",
              count: data?.onGoingCount
                ? data.onGoingCount - data.transferCount
                : 0,
              isActive:
                pathname.includes("/qna/ongoing") ||
                search.includes("status=대기중"),
            },
            {
              label: "답변완료",
              path: "/qna/completed",
              isActive:
                pathname.includes("/qna/completed") ||
                search.includes("status=답변+완료"),
            },
            {
              label: "내 답변",
              path: "/qna/answered",
              isActive:
                pathname.includes("/qna/answered") || search.includes("mine=1"),
            },
          ],
        },
        ...(user?.grade?.id === 1
          ? [
              {
                label: "이관현황",
                links: [
                  {
                    label: "대기중",
                    path: "/qna/transfer",
                    count: data?.transferCount,
                    isActive:
                      pathname.includes("/qna/transfer") ||
                      search.includes("transfer=1"),
                  },
                ],
              },
            ]
          : []),
      ]}
    />
  );
};

export default QnaPage;
